import useInfiniteFetch from '@hooks/useInfiniteFetch';

const useCuratedPlaylist = (key, options = { fallbackData: undefined }) => {
  const { data, isValidating, isError, ...rest } = useInfiniteFetch(
    key,
    {
      applyOffsetsAutomatically: false
    },
    {
      revalidateFirstPage: false,
      fallbackData: options.fallbackData
    }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(data || {});

  return {
    key,
    data,
    isValidating,
    ...rest
  };
};

export default useCuratedPlaylist;
